"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatEecText = formatEecText;
const vehicleKey_1 = require("../utils/vehicleKey");
const constants_1 = require("./constants");
const mustacheRenderer_1 = require("./renderer/mustacheRenderer");
function formatEecText(resources, vehicleType, eec, discharged = false) {
    if (!vehicleType || !eec) {
        return undefined;
    }
    const view = {
        eec,
        footnote: {
            reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
        },
    };
    const translationKey = (0, vehicleKey_1.getTranslationKeyForVehicleType)("vue.eec", vehicleType, { discharged });
    return (0, mustacheRenderer_1.substituteTemplate)(resources.get(translationKey), view);
}
